export default __webpack_public_path__ + "static/media/london_the_city_look_up.3bf62604.jpg";